import { render, staticRenderFns } from "./VoyageCompareChart.vue?vue&type=template&id=d139c65c&scoped=true"
import script from "./VoyageCompareChart.vue?vue&type=script&lang=js"
export * from "./VoyageCompareChart.vue?vue&type=script&lang=js"
import style0 from "./VoyageCompareChart.vue?vue&type=style&index=0&id=d139c65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d139c65c",
  null
  
)

export default component.exports